/**
 * Returns an array of instances which are mapped by keys in the `domainMapData`.
 * The `domainList` provide the instances' keys.
 * NOTE: this function preserversReduxUtil the order of the given keys.
 *
 * @param  {Object} [domainMapData={}]
 * @param  {String[]|Number[]} [domainListData=[]]
 * @returns {Instance[]}
 */
export default function getInstancesFromDomainMapReduxUtil (
  domainMapData = {},
  domainListData = []
) {
  return domainListData.reduce((instances, instanceKey) => {
    const instance = domainMapData[instanceKey]
    if (instance) {
      instances.push(instance)
    }
    return instances
  }, [])
}
